import { Dialog, Loading, Notify } from 'quasar';
import { defineAsyncComponent } from 'vue';

function showErrorNotification(errorMessage) {
  Loading.hide();

  Notify.create({
    color: 'negative',
    position: 'top',
    message: errorMessage,
    icon: 'report_problem'
  });
}

function showSuccessNotification(message, position = 'top') {
  Loading.hide();

  Notify.create({
    color: 'green-5',
    textColor: 'white',
    icon: 'done',
    position,
    message
  });
}

// Neither a failure nor a success: something happened that the user needs to
// know about but did not do wrong (losing a claim race to another coach).
function showWarningNotification(message, position = 'top') {
  Loading.hide();

  Notify.create({
    color: 'warning',
    textColor: 'black',
    icon: 'info',
    position,
    message
  });
}

function showLoadingNotification(message, position = 'top') {
  Loading.hide();

  Notify.create({
    color: 'accent',
    textColor: 'white',
    icon: 'autorenew',
    position,
    message,
    timeout: 1500
  });
}

function showSocketNotification(message, position = 'top') {
  Notify.create({
    color: 'warning',
    textColor: 'black',
    icon: 'rss_feed',
    position,
    message,
    timeout: 2500,
    html: true
  });
}

function showNewMessageNotification(data, position = 'top') {
  Dialog.create({
    component: defineAsyncComponent(() => import('src/components/Notifications/NewMessage.vue')),
    componentProps: { modelValue: data }
  })
    .onOk(() => {})
    .onCancel(() => {})
    .onDismiss(() => {});
}

function showPermanentNotification(message, color, position = 'top') {
  Notify.create({
    color: 'warning',
    textColor: 'black',
    timeout: 0, // we want to be in control when it gets dismissed
    message: message,
    actions: [
      {
        label: 'Ok',
        color: 'white',
        handler: () => {
          /* ... */
        }
      }
    ]
  });
}

export {
  showErrorNotification,
  showLoadingNotification,
  showNewMessageNotification,
  showPermanentNotification,
  showSocketNotification,
  showSuccessNotification,
  showWarningNotification
};
